module.exports = __webpack_public_path__ + "static/cad-designs14-f523b2d76759a71df2c1135253aee179.png";